import { fetchFile } from '@ffmpeg/util';
import { createRNNWasmModule } from '@jitsi/rnnoise-wasm';

export const processNoiseRemoval = async (ffmpeg, audioFile, method) => {
  await ffmpeg.writeFile('input_audio', await fetchFile(audioFile));

  if (method === 'ai') {
    // 1. Prepare PCM Float32
    await ffmpeg.exec([
      '-i', 'input_audio',
      '-f', 'f32le', '-ar', '44100', '-ac', '1', 'input.raw'
    ]);

    const rawData = await ffmpeg.readFile('input.raw');
    const wasmModule = await createRNNWasmModule({
      locateFile: (path) => `/${path}`
    });

    const FRAME_SIZE = 480;
    const SHIFT = 32768; 
    const bufferSize = FRAME_SIZE * 4;

    const wasmInput = wasmModule._malloc(bufferSize);
    const f32HeapIndex = wasmInput >> 2; 
    const context = wasmModule._rnnoise_create();

    const inputF32 = new Float32Array(rawData.buffer);
    const outputF32 = new Float32Array(inputF32.length);

    for (let i = 0; i + FRAME_SIZE <= inputF32.length; i += FRAME_SIZE) {
      for (let j = 0; j < FRAME_SIZE; j++) {
        wasmModule.HEAPF32[f32HeapIndex + j] = inputF32[i + j] * SHIFT;
      }
      wasmModule._rnnoise_process_frame(context, wasmInput, wasmInput);
      for (let j = 0; j < FRAME_SIZE; j++) {
        outputF32[i + j] = wasmModule.HEAPF32[f32HeapIndex + j] / SHIFT;
      }
    }

    wasmModule._rnnoise_destroy(context);
    wasmModule._free(wasmInput);

    await ffmpeg.writeFile('output.raw', new Uint8Array(outputF32.buffer));
    await ffmpeg.exec([
      '-f', 'f32le', '-ar', '44100', '-ac', '1', '-i', 'output.raw',
      '-b:a', '192k', 'cleaned_ai.mp3'
    ]);

    const data = await ffmpeg.readFile('cleaned_ai.mp3');
    return URL.createObjectURL(new Blob([data.buffer], { type: 'audio/mp3' }));
  } else {
    // Standard FFmpeg Denoise
    await ffmpeg.exec([
      '-i', 'input_audio',
      '-af', 'highpass=f=80,afftdn=nf=-25,lowpass=f=10000,loudnorm',
      'cleaned_std.mp3'
    ]);
    const data = await ffmpeg.readFile('cleaned_std.mp3');
    return URL.createObjectURL(new Blob([data.buffer], { type: 'audio/mp3' }));
  }
};